// extracted by mini-css-extract-plugin
export default {"tabLink":"style_tabLink__3QOin","tabActive":"style_tabActive__RTETF","tabContent":"style_tabContent__6VqnD"};